import React from "react";
import PropTypes from "prop-types";

const Help = ({ children }) => (
  <p className="help">
    <i>{children}</i>
  </p>
);

Help.propTypes = {
  children: PropTypes.string.isRequired
};

export default Help;
